export default __webpack_public_path__ + "static/media/icon_serpr_square.c8ff03aa.svg";